<div class="cms-filter-dropdown"
     [attr.data-menu-id]="menuId"
     [class.active]="selectedCount > 0"
     [class.open]="isOpen"
     [class.icon-only]="iconOnly">
    <button type="button" class="cms-filter-dropdown__trigger btn-filter" (click)="toggleOpen($event)">
        <span *ngIf="icon" class="cms-filter-dropdown__icon" aria-hidden="true">
            <cms-outline-icon [icon]="icon" [size]="16"></cms-outline-icon>
        </span>
        <span *ngIf="!iconOnly" class="cms-filter-dropdown__label">{{ displayLabel }}</span>
        <span class="cms-filter-dropdown__chevron" aria-hidden="true">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path *ngIf="!isOpen" d="m6 9 6 6 6-6"></path>
                <path *ngIf="isOpen" d="m18 15-6-6-6 6"></path>
            </svg>
        </span>
    </button>

    <div class="cms-filter-dropdown__menu"
         *ngIf="isOpen"
         [class.cms-filter-dropdown__menu--end]="menuAlignEnd"
         (mousedown)="$event.stopPropagation()"
         (click)="$event.stopPropagation()">
        <button type="button"
                *ngFor="let option of options"
                class="cms-filter-dropdown__option"
                [class.is-selected]="isSelected(option.id)"
                (click)="toggleOption(option.id, $event)">
            <span class="cms-filter-dropdown__checkbox" [class.is-checked]="isSelected(option.id)"></span>
            <span class="cms-filter-dropdown__option-label">{{ option.name }}</span>
        </button>
        <p *ngIf="options.length === 0" class="cms-filter-dropdown__empty">No options</p>
    </div>
</div>
